<template>
  <div>
    <step :navItems="navItems" :index="1" :canNext="true" :step="step" v-on:step="updateStep" v-on:back="() => { this.$router.push('/group-mgr') }">
      <template slot="header">
        <form class="form-custom pt-0 bg-white">
          <h2>{{name?$t('class_name') + ':':$t('add_a_class')}}{{name}}</h2>
        </form>
      </template>

      <template slot="body">
        <div class="row">
          <div class="col-sm-8 m-auto">
            <ul class="list-group list-group-flush mt-5">
              <li class="list-group-item border text-left mb-3 rounded"
                style="line-height: 150%;"
                v-for="item in selected">
                <div class="float-left">
                  <span>{{ item.realName }}</span>
                </div>
              </li>
            </ul>
            <pagination v-if="selected.length" class="mt-3" :current="selectedData.pageIndex" :total="selectedData.pageCount" v-on:page="updateSelectedPage" />
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="2" :step="step" :canNext="name?true:false" v-on:step="updateStep">
      <template slot="header">
        <div class="row">
          <input type="text" class="form-control mt-3 col-sm-4 offset-sm-4 my-auto" style="font-size: 24px; padding:20px" :placeholder="$t('enter_class_name')" required v-model="name">
          <div class="col-sm-4">
            <switch-button v-on:status="(status) => { this.switchOn = status }" :leftLabel="$t('class_list')" :rightLabel="$t('selected_students')" />
          </div>
        </div>
      </template>

      <template slot="body">
        <div class="row mt-3">
          <div class="col-8 offset-2">
            <ul class="list-group list-group-flush">
              <li class="list-group-item border text-left mb-3 rounded"
                :class="{ 'active': getSelectedIdx(item.id) > -1 }"
                style="line-height: 150%;"
                v-for="item in students"
                @click="edit(item)">
                <div class="float-left">
                  <span>{{ item.realName }}</span><br>{{ item.userName }}
                </div>
              </li>
            </ul>
            <pagination class="mt-3" :current="pageIndex" :total="pageCount" v-on:page="updatePage" v-if="switchOn" />
          </div>
        </div>
      </template>
    </step>

    <step :navItems="navItems" :index="3" :step="step" v-on:step="updateStep" :canNext="name?true:false" v-on:finish="() => { this.$router.push('/group-mgr') }">
      <template slot="header">
        <h3>{{$t('complete')}}</h3>
      </template>

      <template slot="body">
        <div class="col-8 offset-2">
          <ul class="list-group list-group-flush">
            <li class="list-group-item border text-left mb-3 rounded"
              style="line-height: 150%;">
              <span>
                {{ name }}<br>{{$t('established_date')}}：{{ '2019-01-01 00:00' }}
              </span>
              <span class="float-right">
                {{$tc('student', selected.length,{count:selected.length })}}
              </span>
            </li>
          </ul>
        </div>
      </template>
    </step>
  </div>
</template>

<script>
import lessonFilterMixin from '../../components/lessonFilterMixin'
import langMixin from '../../components/langMixin'
import Pagination from '../../components/Pagination'
import Step from './Step'
import api from '../../store/api'
import selectMixin from './selectMixin'
import SwitchButton from './SwitchButton'

export default {

  name: 'TeachingGroupEditor',

  components: {
    Pagination,
    Step,
    SwitchButton
  },

  mixins: [lessonFilterMixin, langMixin, selectMixin],

  data () {
    return {
      selectedData: {},
      groupId: null,
      step: 1,
      switchOn: true,
      name: '',
      navItems: [this.$t('add_or_select'), this.$t('class_list'), this.$t('add_or_delete_class'), this.$t('complete')],
      list: [],
      pageIndex: 1,
      pageCount: 0,
      pageSize: 10
    }
  },

  computed: {
    mode () {
      return (this.$route.name === 'group-mgr.add') ? 'add' : 'edit'
    },

    students () {
      return this.switchOn ? this.list : this.selected
    }
  },

  async mounted () {
    if (this.mode === 'add') {
      this.step = 2
      // this.navItems = ['新增或選擇清單', '班級列表', '輸入班級資訊', '完成']
    }
    this.groupId = this.$route.params.groupId
    let params = {
      'pageSize': this.pageSize
    }
    this.getList(params)

    if (this.groupId) {
      const { data } = await api.get('/GroupMgr/TeachingGroups/' + this.groupId)
      if (data.status === 'OK') {
        this.name = data.data.name
        this.getSelectedList(params)
      }
    }
  },

  methods: {
    async getList (params) {
      const { data } = await api.get('/StudentMgr/Students', { params: params })

      if (data.status === 'OK') {
        this.list = data.data
        this.pageIndex = data.pageIndex
        this.pageCount = data.pageCount
      }
    },

    async getSelectedList (params) {
      let self = this
      api.get('/GroupMgr/TeachingGroups/' + this.groupId + '/students', { params: params })
      .then((res) => {
        self.selectedData = res.data
        self.selected = res.data.data || []
      })
    },

    updateSelectedPage (page) {
      this.getSelectedList({
        'pageSize': this.pageSize,
        'pageIndex': page
      })
    },

    updatePage (page) {
      this.getList({
        'pageSize': this.pageSize,
        'pageIndex': page
      })
    },

    updateStep (step) {
      if (step === 3 && this.mode === 'add') {
        this.add()
      } else if (step === 3 && this.groupId) {
        this.updateName()
      }

      this.step = step
    },

    async add () {
      let fileData = new window.FormData()
      fileData.append('name', this.name)

      const { data } = await api.post('/GroupMgr/TeachingGroups', fileData)

      if (data.status === 'OK') {
        this.groupId = data.data.id
        this.addStudentToGorup()
      }
    },

    async updateName () {
      let fileData = new window.FormData()
      fileData.append('name', this.name)

      const { data } = await api.patch('/GroupMgr/TeachingGroups/' + this.groupId, fileData)

      if (data.status === 'OK') {
        console.log('Update Name Success')
      }
    },

    async addStudentToGorup () {
      let groupForm = new window.FormData()
      for (let idx in this.selected) {
        groupForm.append('studentIds', this.selected[idx].id)
      }
      const { data } = await api.post('/GroupMgr/TeachingGroups/' + this.groupId + '/Students', groupForm)

      if (data.status === 'OK') {
        console.log('Success')
      }
    },

    async edit (item) {
      if (this.mode === 'add') {
        this.select(item)
        return
      }

      let action = (this.getSelectedIdx(item.id) > -1) ? 'delete' : 'post'
      let formData = new window.FormData()
      formData.append('studentIds', [item.id])

      if (action === 'delete') {
        formData = {
          data: formData
        }
      }

      const { data } = await api[action]('/GroupMgr/TeachingGroups/' + this.groupId + '/Students', formData)

      if (data.status === 'OK') {
        this.select(item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/color.scss';

.list-group-item.active {
  background-color: $main-color;
}
</style>


// WEBPACK FOOTER //
// TeachingGroupEditor.vue?25d23960